import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative flex flex-row flex-initial w-full bg-white p-3.5 lg:hidden z-20" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-full h-full select-none pointer-events-none",
  src: "/icons/burger.svg",
  alt: "Меню"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "flex-initial ml-auto w-7 opacity-30 select-none pointer-events-none",
  title: "Открыть уведомления",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full h-full select-none pointer-events-none",
    src: "/icons/bell.svg",
    alt: "Уведомления"
  })
], -1)
const _hoisted_5 = { class: "flex-initial w-full items-center space-x-4 p-2 mb-5 hidden lg:flex" }
const _hoisted_6 = { class: "flex-auto w-full flex flex-col flex-nowrap space-y-2 text-sm h-5/6 overflow-auto pb-16 lg:pb-0" }
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Есть непрочитанные сообщения от клиентов", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-4",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
  })
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "flex-initial w-full mt-auto"
}
const _hoisted_15 = { class: "flex-auto w-full flex" }
const _hoisted_16 = {
  href: "/logout",
  class: "mt-auto flex-initial flex w-full text-center justify-center items-center space-x-3 text-gray-700 p-2 rounded-md font-medium hover:bg-gray-200 focus:bg-gray-200 focus:shadow-outline"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 flex-initial" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-4",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
    })
  ])
], -1)
const _hoisted_18 = {
  key: 0,
  class: "flex-initial",
  textContent: 'Выйти'
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_MessengerNotifications = _resolveComponent("MessengerNotifications")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isCollapsed)
      ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, _ctx.$attrs, { class: "flex-initial w-20 mr-px" }), null, 16))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "flex-initial w-8",
        title: "Открыть/Закрыть меню",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMobileOpened = !_ctx.isMobileOpened))
      }, _hoisted_3),
      _hoisted_4
    ]),
    _createElementVNode("div", _mergeProps({ class: "" }, _ctx.$attrs, {
      class: [
            'fixed top-14 lg:top-0 flex flex-col flex-nowrap z-20',
            'bg-white rounded py-3 px-10 lg:px-3 border-r',
            'h-full',
            'transform lg:transform-none transition-transform',
            {
                // Desktop Collapse
                'lg:relative w-full lg:w-1/3 xl:w-1/4 2xl:w-1/5': !_ctx.isCollapsed,
                'lg:fixed top-0 left-0 min-h-full w-auto z-20': _ctx.isCollapsed,
                // Mobile Collapse
                '-translate-x-full': !_ctx.isMobileOpened,
                'translate-x-0': _ctx.isMobileOpened,
            },
        ]
    }), [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: "flex-initial ml-auto flex h-10 w-10 justify-center items-center text-gray-700 p-2 rounded-md font-medium hover:bg-gray-200 focus:bg-gray-200 focus:shadow-outline",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["flex-auto bg-gray-600 h-5 w-full transform", { 'rotate-180': _ctx.isCollapsed }]),
            style: {"-webkit-mask":"url('/icons/double-chevron.svg') center no-repeat","mask":"url('/icons/double-chevron.svg') center no-repeat"}
          }, null, 2)
        ])
      ]),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userServices, (service) => {
          return (_openBlock(), _createElementBlock("li", {
            key: service.id,
            class: "flex-initial w-full"
          }, [
            _createVNode(_component_ElTooltip, {
              disabled: !_ctx.isCollapsed,
              content: service.title,
              placement: "right"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(service.forceExternalOpen ? 'a' : 'button'), _mergeProps({
                  class: ["relative flex w-full text-left items-center space-x-2 text-gray-700 p-2 rounded-md font-medium hover:bg-gray-200 focus:bg-gray-200 focus:shadow-outline", {
                            'bg-gray-200': service.id === _ctx.openedService.id,
                            'justify-center': _ctx.isCollapsed,
                        }]
                }, 
                            service.forceExternalOpen
                                ? {
                                      href: service.url,
                                      target: '_blank',
                                  }
                                : {
                                      type: 'button',
                                  }
                        , {
                  onClick: ($event: any) => (_ctx.openService(service, false))
                }), {
                  default: _withCtx(() => [
                    (service.iconUri)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "flex-initial bg-gray-600 w-4 h-4",
                          style: _normalizeStyle([
                                '-webkit-mask: url(' + service.iconUri + ') no-repeat center',
                                'mask: url(' + service.iconUri + ') no-repeat center',
                            ])
                        }, null, 4))
                      : _createCommentVNode("", true),
                    (service.name === 'messenger.agent' && _ctx.messengerUnreadCount > 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(["flex-shrink-0 w-2.5 h-2.5 rounded-full bg-red-500", { 'absolute top-1 right-1': _ctx.isCollapsed }]),
                          title: 'Чатов с непрочитанными сообщениями: ' + _ctx.messengerUnreadCount,
                          role: "status"
                        }, _hoisted_9, 10, _hoisted_7))
                      : _createCommentVNode("", true),
                    (!_ctx.isCollapsed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("span", {
                            class: "flex-auto lg:text-base",
                            textContent: _toDisplayString(service.title)
                          }, null, 8, _hoisted_10),
                          _createElementVNode("span", {
                            class: "flex-initial mr-auto text-gray-600 cursor-pointer rounded-lg p-1 transition-colors hover:bg-gray-50",
                            onClick: _withModifiers(($event: any) => (_ctx.openService(service, true)), ["stop"])
                          }, _hoisted_13, 8, _hoisted_11)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1040, ["class", "onClick"]))
              ]),
              _: 2
            }, 1032, ["disabled", "content"])
          ]))
        }), 128)),
        (_ctx.hasMessenger)
          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
              _createVNode(_component_MessengerNotifications, {
                collapsed: _ctx.isCollapsed,
                onUnreadChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('messenger-unread-change', $event))),
                onOpenMessenger: _ctx.openMessenger
              }, null, 8, ["collapsed", "onOpenMessenger"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_15, [
          _createVNode(_component_ElTooltip, {
            content: "Выйти",
            placement: "right",
            disabled: !_ctx.isCollapsed
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", _hoisted_16, [
                _hoisted_17,
                (!_ctx.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ], 16)
  ], 64))
}